import { connect } from 'react-redux';
import { get } from 'lodash';

import { hideInfoBox } from 'apps/subscriptions/actions/subscriptions';

import SubscriptionsInfoBoxContainer from '../components/SubscriptionsInfoBoxContainer';

export default connect(
  (state, ownProps) => ({
    subscribedSku: get(state, `subscriptions.subscriptionsBySku['${ownProps.sku}']`) || {},
    showInfoBox: state.subscriptions.showInfoBox || false,
  }),
  { onDismiss: hideInfoBox }
)(SubscriptionsInfoBoxContainer);
